// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"7f25f6d2","506":"0c79fee0","632":"d2c30c96","673":"4e83a7f1"}[chunkId] + ".chunk.js";
};